import React, { useEffect, useMemo, useState } from "react";
import "./filtersPanel.css";

function normalizeSort(value) {
  // compatibilidad: antes se usaba "precio"
  if (value === "precio") return "precioActual";
  return value || "precioActual";
}

export default function FiltersPanel({
  onApply,
  onClear,
  pharmacies = [],
  initial = {},
}) {
  const [farmacia, setFarmacia] = useState(initial.farmacia || "");
  const [sort, setSort] = useState(normalizeSort(initial.sort));
  const [order, setOrder] = useState(initial.order || "asc");
  const [minPrecio, setMinPrecio] = useState(initial.minPrecio ?? "");
  const [maxPrecio, setMaxPrecio] = useState(initial.maxPrecio ?? "");

  useEffect(() => {
    setFarmacia(initial.farmacia || "");
    setSort(normalizeSort(initial.sort));
    setOrder(initial.order || "asc");
    setMinPrecio(initial.minPrecio ?? "");
    setMaxPrecio(initial.maxPrecio ?? "");
  }, [initial]);

  const canApply = useMemo(() => {
    const minOk = minPrecio === "" || Number(minPrecio) >= 0;
    const maxOk = maxPrecio === "" || Number(maxPrecio) >= 0;
    const rangeOk =
      minPrecio === "" ||
      maxPrecio === "" ||
      Number(minPrecio) <= Number(maxPrecio);
    return minOk && maxOk && rangeOk;
  }, [minPrecio, maxPrecio]);

  function apply() {
    if (!canApply) return;

    const payload = {
      farmacia: farmacia || undefined,
      sort,
      order,
      minPrecio: minPrecio !== "" ? Number(minPrecio) : undefined,
      maxPrecio: maxPrecio !== "" ? Number(maxPrecio) : undefined,
    };

    console.log("APPLY FILTERS:", payload);
    onApply(payload);
  }

  function clear() {
    setFarmacia("");
    setSort("precioActual");
    setOrder("asc");
    setMinPrecio("");
    setMaxPrecio("");
    onClear?.();
  }

  return (
    <aside className="filters-panel">
      <h3>Filtros</h3>

      <label className="field">
        <span>Farmacia</span>
        <select value={farmacia} onChange={(e) => setFarmacia(e.target.value)}>
          <option value="">Todas</option>
          {pharmacies.map((f) => (
            <option key={f} value={f}>
              {f}
            </option>
          ))}
        </select>
      </label>

      <label className="field">
        <span>Ordenar por</span>
        <select value={sort} onChange={(e) => setSort(e.target.value)}>
          <option value="precioActual">Precio</option>
          <option value="nombre">Nombre</option>
          <option value="fechaExtraccion">Fecha de extracción</option>
        </select>
      </label>

      <label className="field">
        <span>Dirección</span>
        <select value={order} onChange={(e) => setOrder(e.target.value)}>
          <option value="asc">Ascendente</option>
          <option value="desc">Descendente</option>
        </select>
      </label>

      <div className="field two">
        <label>
          <span>Precio min</span>
          <input
            type="number"
            min="0"
            value={minPrecio}
            onChange={(e) => setMinPrecio(e.target.value)}
            placeholder="0"
          />
        </label>
        <label>
          <span>Precio máx</span>
          <input
            type="number"
            min="0"
            value={maxPrecio}
            onChange={(e) => setMaxPrecio(e.target.value)}
            placeholder="∞"
          />
        </label>
      </div>

      {!canApply && (
        <div className="error-hint">
          Revisa el rango: el mínimo no debe ser mayor al máximo.
        </div>
      )}

      <div className="actions">
        <button className="btn-primary" onClick={apply} disabled={!canApply}>
          Aplicar filtros
        </button>
        <button className="btn-ghost" onClick={clear}>
          Limpiar
        </button>
      </div>
    </aside>
  );
}
